import { render, staticRenderFns } from "./popoverList.vue?vue&type=template&id=c9577dca&scoped=true&"
import script from "./popoverList.vue?vue&type=script&lang=js&"
export * from "./popoverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9577dca",
  null
  
)

component.options.__file = "popoverList.vue"
export default component.exports